// 站內網址一律寫成正式形狀：語言前綴＋結尾斜線（/contact → /contact/、/lineage#f1 → /lineage/#f1）。
// 由來（2026-10-03 全站連結稽核）：二十幾個元件各自寫 local = p => '/zh' + p，都沒補斜線；
// 伺服器對沒斜線的網址回 308，前端雖然認得，但爬蟲與 AI 每條多一跳、canonical 也對不上——全站 5,559 條。
// 有副檔名的（/static/x.pdf、/feed.xml）與站外網址原樣不動。
export function withSlash(href) {
  if (typeof href !== 'string') return href
  const own = href.match(/^(https?:\/\/(?:www\.)?cheyuwu\.com)(\/.*)?$/i)   // 寫成完整網址的本站連結也一樣
  if (own) return own[1] + withSlash(own[2] || '/')
  if (!href.startsWith('/') || href.startsWith('//')) return href
  const cut = href.search(/[?#]/)
  const path = cut < 0 ? href : href.slice(0, cut), rest = cut < 0 ? '' : href.slice(cut)
  if (path.endsWith('/') || /\.[a-z0-9]{1,5}$/i.test(path.split('/').pop())) return href
  return path + '/' + rest
}
export const sitePath = (path, zh) => withSlash((zh ? '/zh' : '') + path)
// marked 擴充：markdown 內文裡手寫的站內連結（[…](/writing/2016-hahow-bet)）也補成正式形狀。用法：marked.use(markedSitePaths)
export const markedSitePaths = { walkTokens(token) { if (token.type === 'link') token.href = withSlash(token.href) } }
